
import { mapActions } from 'vuex'
export default {
  data() {
    return {
      nome_cidade: '',
      cityRender: {},
      overlay: true,
    }
  },
  head() {
    const pageTitle = `Certificado Digital Senha Digital em ${this.nome_cidade}`
    const pageDescription = `Parceiro revendedor de Certificado Digital em ${this.nome_cidade}. Se você é empreendedor e está atento a oportunidades, a Senha Digital tem uma ótima oportunidade para você.`
    const contentSeo = `Certificado Digital Senha Digital em ${this.nome_cidade}`
    return {
      title: pageTitle,
      meta: [
        {
          hid: 'description',
          name: 'description',
          content: pageDescription,
        },
        {
          hid: 'keywords',
          name: 'keywords',
          content: contentSeo,
        },
        {
          hid: 'og:title',
          property: 'og:title',
          content: contentSeo,
        },
        {
          hid: 'og:description',
          property: 'og:description',
          content: `Parceiro Revendedor de Certificado Digital em ${this.nome_cidade}`,
        },

        {
          hid: 'twitter:title',
          name: 'twitter:title',
          content: contentSeo,
        },
        {
          hid: 'twitter:description',
          name: 'twitter:description',
          content: `Parceiro Revendedor de Certificado Digital em ${this.nome_cidade}`,
        },
      ],
    }
  },

  mounted() {
    this.loadCities()
  },
  methods: {
    ...mapActions('actions-site', ['fetchAllCities']),
    async loadCities() {
      try {
        const city = this.$route.params.name
        const data = await this.fetchAllCities(city)
        if (data.length === 0) {
          this.$router.push('/')
          this.$toast.error('Cidade não encontrada')
          return
        }
        this.cityRender = Array.isArray(data) ? data[0] : data
        this.nome_cidade = Array.isArray(data) ? data[0].nome : data.nome
      } catch (error) {
        console.error(error)
      } finally {
        this.overlay = false
      }
    },
    sejaUmaRevenda() {
      this.$router.push('/seja-uma-revenda')
    },
    comprarCertificado() {
      this.$router.push('/')
    },
  },
}
